import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "nth-last-child"
    }}>{`:nth-last-child`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v3.0`}</p>
    <p>{`Matches only the Nth child from the end. Can use an expression or `}<inlineCode parentName="p">{`even`}</inlineCode>{` or `}<inlineCode parentName="p">{`odd`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`See:`}</strong>{` `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/:nth-last-child"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/CSS/:nth-last-child`}</a></p>
    <p><strong parentName="p">{`Example:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.row:nth-last-child(even) {
    background-color: #E8E8E8; /* color even rows (from the end) */
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      